import { useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Process from "@/components/site/Process";
import Services from "@/components/site/Services";
import Reprogrammation from "@/components/site/Reprogrammation";
import Reviews from "@/components/site/Reviews";
import Vehicles from "@/components/site/Vehicles";
import QuoteForm from "@/components/site/QuoteForm";
import Contact from "@/components/site/Contact";
import Admin from "@/pages/Admin";

function Home() {
  const quoteRef = useRef(null);

  const scrollToQuote = (serviceType) => {
    quoteRef.current?.scrollAndPrefill?.(serviceType);
  };

  return (
    <div className="App">
      <Header onQuoteClick={() => scrollToQuote()} />
      <Hero onQuoteClick={() => scrollToQuote()} />
      <Process />
      <Services />
      <Reprogrammation onQuoteClick={scrollToQuote} />
      <Vehicles />
      <Reviews />
      <QuoteForm ref={quoteRef} />
      <Contact />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
